<script>
import {literatureTexts, arts, media} from "./data-sub-axes";

export default {
  props:{
    data: {
      type : Object
    }
  },
  data() {
    return {
      // Chart
      literatureTexts: literatureTexts,
      arts: arts,
      media: media,
    };
  },
  computed:{},
  methods: {},
  created(){},
};
</script>

<template>
  <div>

    <div class="row">
      <div class="col-lg-4 col-md-12 col-sm-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">الادب والنصوص</h4>
            <apexchart
              class="apex-charts pieChart"
              height="380"
              type="pie"
              dir="rtl"
              :series="data.literatureTexts_series"
              :options="literatureTexts.chartOptions"
            ></apexchart>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-md-12 col-sm-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">الفنون</h4>
            <apexchart
              class="apex-charts pieChart"
              height="380"
              type="pie"
              dir="rtl"
              :series="data.arts_series"
              :options="arts.chartOptions"
            ></apexchart>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-md-12 col-sm-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">وسائل الاعلام</h4>
            <apexchart
              class="apex-charts pieChart"
              height="380"
              type="pie"
              dir="rtl"
              :series="data.media_series"
              :options="media.chartOptions"
            ></apexchart>
          </div>
        </div>
      </div>
    </div>

  </div>

</template>